import { render, staticRenderFns } from "./GoldLabel.vue?vue&type=template&id=017d533d&"
import script from "./GoldLabel.vue?vue&type=script&lang=js&"
export * from "./GoldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports